const initialValue = {
  cpn: '',
  poNumber: '',
  qty: '',
  itemSelectablePos: [],
}

export default initialValue
